export class ByteWriter {
  public length = 0;
  public position = 0;
  private buffer = new Uint8Array(128);
  private view = new DataView(this.buffer.buffer);
  private littleEndian = false;

  public getResult(): Uint8Array {
    return this.buffer.slice(0, this.length);
  }

  public set(index: number, value: number) {
    this.view.setUint8(index, value);
  }

  public writeByte(value: number) {
    const position = this.advance(1);
    this.view.setUint8(position, value);
  }

  public writeUTF(value: string) {
    const bytes = utf8Encoder.encode(value);
    const position = this.advance(2 + bytes.length);
    this.view.setUint16(position, bytes.length, this.littleEndian);
    this.buffer.set(bytes, position + 2);
  }

  public writeUTFBytes(value: string) {
    const bytes = utf8Encoder.encode(value);
    const position = this.advance(bytes.length);
    this.buffer.set(bytes, position);
  }

  private advance(add: number) {
    const position = this.position;
    const bufferLength = this.buffer.length;
    const newPosition = position + add;
    if (bufferLength < newPosition) {
      const newLength = Math.max(bufferLength * 2, newPosition);
      const newBuffer = new Uint8Array(newLength);
      newBuffer.set(this.buffer);
      this.buffer = newBuffer;
      this.view = new DataView(this.buffer.buffer);
    }
    this.position = newPosition;
    if (this.length < newPosition) {
      this.length = newPosition;
    }
    return position;
  }
}

const utf8Encoder = new TextEncoder();
